import { IconType } from './../../enums/iconType';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-icon-tooltip',
    templateUrl: './icon-tooltip.component.html',
    styleUrls: ['./icon-tooltip.component.scss'],
    standalone: false
})
export class IconTooltipComponent implements OnInit {
  isVisible: boolean;
  hasBeenClicked: boolean;
  @Input() tooltipIconId: string;
  @Input() iconType: IconType;
  targetId: string;
  shouldShow = false;
  iconTypes = IconType;
  @Output() componentChanged = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    this.targetId = '#' + this.tooltipIconId;
  }

  onIconClick() {
    this.hasBeenClicked = true;
    this.shouldShow = !this.shouldShow;
    this.isVisible = this.shouldShow;
    this.componentChanged.emit();
  }

  onIconMouseEnter() {
    if (!this.hasBeenClicked) {
      this.isVisible = true;
    }
    this.componentChanged.emit();
  }

  onIconMouseLeave() {
    if (this.hasBeenClicked) {
      this.isVisible = true;
    } else {
      this.isVisible = false;
    }
    this.componentChanged.emit();
  }

  onHidingTooltip() {
    this.hasBeenClicked = false;
    this.shouldShow = false;
    this.componentChanged.emit();
  }
}
